import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { InspectionCompletionProcessingSchema } from '../entities/inspectionCompletionProcessing.js';
export const GetInspectionCompletionProcessingApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
    }),
    // null means processing has not run yet (e.g. inspection not yet completed, or not started).
    response: InspectionCompletionProcessingSchema.nullable(),
};
export const GetInspectionCompletionProcessingRequestSchema = GetInspectionCompletionProcessingApiSchema.params;
